import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/outline'
import Link from 'next/link'
import { FC, useCallback, useState } from 'react'

import { IFAQPost } from '../../stores/courses'

interface IFAQAccordionProps {
  faqList: IFAQPost[]
  handler?: () => void
  defaultOpenIdx?: number
}

interface IFAQPostProps {
  faq: IFAQPost
  handler?: () => void
  defaultOpen?: boolean
}

const FAQPost: FC<IFAQPostProps> = ({ faq, handler, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const onFAQOpenHandler = useCallback(() => {
    setIsOpen(!isOpen)
    if (handler) {
      handler()
    }
  }, [handler, isOpen])
  return (
    <div className={'overflow-hidden rounded-lg border border-gray-200 bg-gray-50 '}>
      <div
        className={`flex cursor-pointer items-center px-4 py-3 lg:px-5 lg:py-4 ${
          isOpen ? 'border-b border-gray-200' : ''
        }`}
        onClick={onFAQOpenHandler}>
        <div className="flex max-w-full flex-1 items-center">
          <p className={`text-sm font-medium lg:text-base ${isOpen ? '' : 'truncate'}`}>
            {faq.title}
          </p>
          <div className="ml-auto pl-2">
            {isOpen ? (
              <ChevronUpIcon className="h-auto w-5 shrink-0" />
            ) : (
              <ChevronDownIcon className="h-auto w-5 shrink-0" />
            )}
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="w-full bg-white px-4 py-4 lg:px-5">
          <div className="flex items-start">
            <div className="-mt-1 text-sm font-normal lg:text-base">
              <div
                dangerouslySetInnerHTML={{
                  __html: faq.content,
                }}
              />
              {faq.link && (
                <Link href={faq.link.url}>
                  <a className="mt-4 block text-sm font-normal lg:text-base" rel="noreferrer">
                    {faq.link.text}
                  </a>
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const FAQAccordion: FC<IFAQAccordionProps> = ({ faqList, handler, defaultOpenIdx }) => {
  return (
    <>
      <div className="flex flex-col space-y-2 lg:space-y-4">
        {faqList?.map((faq, idx) => {
          const defaultOpen = defaultOpenIdx === idx
          return <FAQPost key={faq.title} faq={faq} defaultOpen={defaultOpen} handler={handler} />
        })}
      </div>
    </>
  )
}

export default FAQAccordion
